import { createSelector } from 'reselect';
const selectAuthState = state => state.auth;
export const selectIsAuthenticated = createSelector(selectAuthState, state => state.isLoggedIn);
export const selectIsAuthInitialized = createSelector(selectAuthState, state => state.initialized);